import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import styles from '../../css/modals/FormDenunciation.module.css'
import { config } from '../../config'
import { Message } from 'primereact/message'
import { formatDateDenunciations } from '../generals/charts/utils/DatesFormats'
import { useTranslation } from 'react-i18next'

export default function FormDenunciation ({ data, setData, setFile, mode, setMode, errorDenunciation }) {
//   console.log(data)
  const { t } = useTranslation('dashboardDevice')
  const [viewSelect, setViewSelect] = useState(false)
  const [selectedDenunciationStatus, setSelectedDenunciationStatus] = useState(null)

  const denunciationStatus = [
    { name: t('modalInforms.label3'), code: 'open' },
    { name: t('modalInforms.label4'), code: 'monitoring' },
    { name: t('modalInforms.label5'), code: 'close' }
  ]

  const tomorrow = new Date()

  useEffect(() => {
    // console.log(data)
    if (data?.denunciationNumber !== null && mode !== 'upload' && mode !== 'editStatus' && mode !== 'edit') setMode('read')
    if (data?.denunciationStatus !== null) setSelectedDenunciationStatus(data?.denunciationStatus === t('modalInforms.label3') ? { name: t('modalInforms.label3'), code: 'open' } : data?.denunciationStatus === t('modalInforms.label4') ? { name: t('modalInforms.label4'), code: 'monitoring' } : { name: t('modalInforms.label5'), code: 'close' })
  }, [data])

  return (
    <div>
            <div className={styles.divButtons}>
                {mode === 'empty' && <Button className={styles.upload_btn} severity="secondary" label={t('modalInforms.label14')} onClick={() => setMode('upload')} />}
                {((data?.denunciationNumber !== null && data?.denunciationStatus !== t('modalInforms.label5') && mode !== 'upload' && mode !== 'edit') || (data?.denunciationStatus === t('modalInforms.label5') && mode === 'editStatus')) && <Button className={styles.edit_btn} label={t('modalInforms.label15')} severity="secondary" onClick={() => setMode('edit')} />}
            </div>
            {mode === 'empty' && <p>{t('modalInforms.label16')}</p>}
            {mode === 'read' && <div className={styles.principalDiv}>
                <p><span>{t('modalInforms.label17')}</span> {data?.denunciationNumber}</p>
                <div className={styles.status}>
                    {!viewSelect && <p><span>{t('modalInforms.label18')}</span> {data?.denunciationStatus}</p>}
                    {data && data?.denunciationStatus !== 'Cerrada' && !viewSelect && <Button className={styles.buttonsDS} icon="pi pi-pencil" rounded outlined severity="secondary" tooltip={t('modalInforms.label19')} tooltipOptions={{ position: 'bottom' }}
                    onClick={() => {
                      setViewSelect(true)
                      setMode('editStatus')
                    }}/>}
                </div>
                {viewSelect && <p><span>{t('modalInforms.label18')}</span> <Dropdown value={selectedDenunciationStatus} onChange={(e) => setSelectedDenunciationStatus(e.value)} options={denunciationStatus} optionLabel="name" placeholder={t('modalInforms.placeholder1')} className={styles.dropdownDS} /></p>}
                <p><span>{t('modalInforms.label20')}</span> {data?.investigator}</p>
                <p><span>{t('modalInforms.label21')}</span> {formatDateDenunciations(data?.incidentDate)}</p>
                <p><span>{t('modalInforms.label22')}</span> {formatDateDenunciations(data?.denunciationDate)}</p>
                <p><span>{t('modalInforms.label23')}</span> <a href={`${config.backend.httpHostBackendFile}:${config.backend.httpPortBackendFile}/download/Denunciations/${data?.device?.licence}_${data?.denunciationNumber}/${data?.fileExtension}/${data?.file}`} target='_blank' className={styles.file_link} rel="noreferrer">{data?.file}</a></p>
                <p><span>{t('modalInforms.label24')}</span> {data?.recoveryDate !== t('modalInforms.noDisponible') ? formatDateDenunciations(data?.recoveryDate) : data?.recoveryDate}</p>
            </div>}
            {mode === 'edit' && <div className={styles.principalDiv}>
                <p><span>{t('modalInforms.label17')}</span> {data?.denunciationNumber}</p>
                <p><span>{t('modalInforms.label23')}</span> {data?.file}</p>
                <p><span>{t('modalInforms.label18')}</span> <Dropdown value={selectedDenunciationStatus} options={denunciationStatus} optionLabel="name" placeholder={t('modalInforms.placeholder1')} className={styles.dropdownDS} id={'denunciationStatus'} onChange={(e) => {
                  setSelectedDenunciationStatus(e.value)
                  setData(e)
                }}/></p>
                <div
                    key={'divKeyIncidentDate'}
                    id={'divIncidentDate'}
                    className={styles.div_input_date}
                >
                    <label>{t('modalInforms.label21')}</label>
                    <input
                        key={'keyIncidentDate'}
                        id={'incidentDate'}
                        name={'incidentDate'}
                        value={data?.incidentDate}
                        onChange={(e) => setData(e)}
                        type={'date'}
                        className={styles.input_denunciation_date}
                        max={tomorrow.toISOString().split('T')[0]}
                    />
                </div>
                <div
                    key={'divKeyDenunciationDate'}
                    id={'divDenunciationDate'}
                    className={styles.div_input_date}
                >
                    <label>{t('modalInforms.label22')}</label>
                    <input
                        key={'keyDenunciationDate'}
                        id={'denunciationDate'}
                        name={'denunciationDate'}
                        value={data?.denunciationDate}
                        onChange={(e) => setData(e)}
                        type={'date'}
                        className={styles.input_denunciation_date}
                        max={tomorrow.toISOString().split('T')[0]}
                    />
                </div>
                <div
                key={'divKeyRecoveryDate'}
                id={'divRecoveryDate'}
                className={styles.div_input_date}
                >
                    <label>{t('modalInforms.label24')}</label>
                    <input
                        key={'keyRecoveryDate'}
                        id={'recoveryDate'}
                        name={'recoveryDate'}
                        value={data?.recoveryDate !== t('modalInforms.noDisponible') ? data?.recoveryDate : null}
                        onChange={(e) => setData(e)}
                        type={'date'}
                        className={styles.input_denunciation_date}
                        max={tomorrow.toISOString().split('T')[0]}
                    />
                </div>
                <div
                    id={'divInvestigator'}
                    key={'divKeyInvestigator'}
                    className={styles.div_input}
                >
                    <label>{t('modalInforms.label20')}</label>
                    <input
                        key={'keyInvestigator'}
                        id={'investigator'}
                        name={'investigator'}
                        onChange={(e) => setData(e)}
                        type={'text'}
                        className={styles.input_denunciation}
                        value={data?.investigator}
                    />
                </div>
            </div>}
            {mode === 'editStatus' && <div className={styles.principalDiv}>
                <p><span>{t('modalInforms.label17')}</span> {data?.denunciationNumber}</p>
                {viewSelect && <p><span>{t('modalInforms.label18')}</span> <Dropdown value={selectedDenunciationStatus} options={denunciationStatus} optionLabel="name" placeholder={t('modalInforms.placeholder1')} className={styles.dropdownDS} id={'denunciationStatus'}
                onChange={(e) => {
                  setSelectedDenunciationStatus(e.value)
                  setData(e)
                }}/></p>}
                <p><span>{t('modalInforms.label20')}</span> {data?.investigator}</p>
                <p><span>{t('modalInforms.label21')}</span> {data?.incidentDate}</p>
                <p><span>{t('modalInforms.label22')}</span> {data?.denunciationDate}</p>
                <p><span>{t('modalInforms.label23')}</span> <a href={`${config.backend.httpHostBackendFile}:${config.backend.httpPortBackendFile}/download/Denunciations/${data?.device?.licence}_${data?.denunciationNumber}/${data?.fileExtension}/${data?.file}`} target='_blank' className={styles.file_link} rel="noreferrer">{data?.file}</a></p>
                <p><span>{t('modalInforms.label24')}</span> {data?.recoveryDate}</p>
            </div>}
            {mode === 'upload' && <div>
                <div
                    key={'divKeyIncidentDate'}
                    id={'divIncidentDate'}
                    className={styles.div_input_date}
                >
                    <label>{t('modalInforms.label21')}</label>
                    <input
                        key={'keyIncidentDate'}
                        id={'incidentDate'}
                        name={'incidentDate'}
                        onChange={(e) => setData(e)}
                        type={'date'}
                        max={tomorrow.toISOString().split('T')[0]}
                        className={styles.input_denunciation_date}
                    />
                </div>
                <div
                    key={'divKeyDenunciationDate'}
                    id={'divDenunciationDate'}
                    className={styles.div_input_date}
                >
                    <label>{t('modalInforms.label22')}</label>
                    <input
                        key={'keyDenunciationDate'}
                        id={'denunciationDate'}
                        name={'denunciationDate'}
                        onChange={(e) => setData(e)}
                        type={'date'}
                        max={tomorrow.toISOString().split('T')[0]}
                        className={styles.input_denunciation_date}
                    />
                </div>
                <div
                    id={'divDenunciationNumber'}
                    key={'divKeyDenunciationNumber'}
                    className={styles.div_input}
                >
                    <label>{t('modalInforms.label17')}</label>
                    <input
                        key={'keyDenunciationNumber'}
                        id={'denunciationNumber'}
                        name={'denunciationNumber'}
                        onChange={(e) => setData(e)}
                        type={'text'}
                        className={styles.input_denunciation}
                    />
                </div>
                <div
                    id={'divInvestigator'}
                    key={'divKeyInvestigator'}
                    className={styles.div_input}
                >
                    <label>{t('modalInforms.label20')}</label>
                    <input
                        key={'keyInvestigator'}
                        id={'investigator'}
                        name={'investigator'}
                        onChange={(e) => setData(e)}
                        type={'text'}
                        className={styles.input_denunciation}
                    />
                </div>
                <div
                    key="divDenunciationFile"
                    id="divDenunciationFile"
                    className={styles.div_input}
                >
                    <label>{t('modalInforms.label23')}</label>
                    <input
                        key="keyDenunciationFile"
                        id="denunciationFile"
                        name="keyDenunciationFile"
                        type="file"
                        accept="image/*,.pdf"
                        className={styles.fancy_file}
                    />
                    <label htmlFor="denunciationFile" className={styles.fancy_file_label}>
                        <span className={styles.fancy_file_button} onClick={() => setFile() }><i className="pi pi-download"></i></span>
                        <span className={styles.fancy_file_name}><span id="file_name_document">{t('modalInforms.label6')}</span></span>
                    </label>
                </div>
            </div>}
            {errorDenunciation && <Message
                                    style={{
                                    /* border: 'solid #696cff', */
                                    /* borderWidth: '1px 1px 1px 0.5rem', */
                                    /* backgroundColor: 'white', */
                                      fontWeight: '600',
                                      padding: '0.4rem',
                                      width: '100%'
                                    }}
                                    severity="error"
                                    text={t('modalInforms.label25')}
                                />}
    </div>
  )
}

FormDenunciation.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.func,
  setFile: PropTypes.func,
  mode: PropTypes.string,
  setMode: PropTypes.func,
  errorDenunciation: PropTypes.bool
}
